import React, { useState, useEffect, useMemo } from 'react';
import { translatedMessage } from '../../service/LanguageService';
import { CompetitionService } from '../../service/CompetitionService';

import CompetitionCalendarViewComponent from './CompetitionCalendarViewComponent';
import CompetitionJobListViewComponent from './CompetitionJobListViewComponent';
import CompetitionRequirementComponent from './CompetitionRequirementComponent';
import CompetitionWorkSeniorityComponent from './CompetitionWorkSeniorityComponent';
import CompetitionEducationListViewComponent from './CompetitionEducationListViewComponent';
import CompetitionTrainingReqViewComponent from './CompetitionTrainingReqViewComponent';
import CompetitionItKnowledgeListViewComponent from './CompetitionItKnowledgeListViewComponent';
import CompetitionLanguageListViewComponent from './CompetitionLanguageListViewComponent';
import CompetitionJobApprovalViewComponent from './CompetitionJobApprovalViewComponent';
import CompetitionOtherConditionViewComponent from './CompetitionOtherConditionViewComponent';
import CompetitionBibliographyListViewComponent from './CompetitionBibliographyListViewComponent';
import CompetitionDocumentViewComponent from './CompetitionDocumentViewComponent';
import CompetitionOtherCompetencyListViewComponent from './CompetitionOtherCompetencyListViewComponent';
import CompetitionWorkDurationViewComponent from './CompetitionWorkDurationViewComponent';
import CompetitionJobDutyViewComponent from './CompetitionJobDutyViewComponent';
import CompetitionUtils from '../../utilities/CompetitionUtils';

const CompetitionJobDetailsComponent = (props) => {
    const [competition, setCompetition] = useState(null);

    const competitionService = useMemo(() => new CompetitionService(), []);

    useEffect(() => {
        setCompetition(props.competition);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [competitionService, props]);

    return (
        <>
            <div className='col-12 md:col-6'>
                <div className='filed-label'>{translatedMessage('competition.institution')}</div>
                <div className='filed-value'>{competition?.institution?.name ? competition?.institution.name : "-"}</div>
            </div>
            <div className="col-12 md:col-6">
                <div className="filed-label">{translatedMessage('generic.status')}</div>
                <div className="filed-value">
                    <span className={`w-min status status-competition-${competition?.status.toString().toLowerCase()}`}>
                        {CompetitionUtils.getCompetitionStatus(competition)}
                    </span>
                </div>
            </div>
            <div className="col-12">
                <div className="filed-label">{translatedMessage('competition.positionCategory')}</div>
                <div className="filed-value">
                    {competition?.positionCategory ? translatedMessage("PositionCategory." + competition?.positionCategory) : "-"}
                </div>
            </div>
            <div className='col-12'>
                <div className='filed-label'>{translatedMessage('competition.legalBasis')}</div>
                <div className='filed-value'>{competition?.legalBasis ? competition?.legalBasis?.label : "-"}</div>
            </div>

            

            {competition?.contactName && <>
                <div className="col-12 mt-3"><h5 className='mb-1'>{translatedMessage("competition.contactPerson")}</h5></div>
                <div className='col-12 md:col-6'>
                    <div className='filed-label'>{translatedMessage('competition.contactName')}</div>
                    <div className='filed-value'>{competition?.contactName ? competition?.contactName : "-"}</div>
                </div>
                <div className='col-12 md:col-6'>
                    <div className='filed-label'>{translatedMessage('competition.contactPosition')}</div>
                    <div className='filed-value'>{competition?.contactPosition ? competition?.contactPosition : "-"}</div>
                </div>
                <div className='col-12 md:col-6'>
                    <div className='filed-label'>{translatedMessage('competition.contactPhone')}</div>
                    <div className='filed-value'>{competition?.contactPhone ? competition?.contactPhone : "-"}</div>
                </div>
                <div className='col-12 md:col-6'>
                    <div className='filed-label'>{translatedMessage('competition.contactEmail')}</div>
                    <div className='filed-value'>{competition?.contactEmail ? competition?.contactEmail : "-"}</div>
                </div>
            </>}            

            {props?.hideJobs !== true &&
                <CompetitionJobListViewComponent competition={props?.competition} />
            }

            <CompetitionCalendarViewComponent competition={props?.competition} />

            <CompetitionRequirementComponent competition={props?.competition} />

            <CompetitionWorkDurationViewComponent competition={props?.competition} />

            <CompetitionJobDutyViewComponent competition={props?.competition} />

            <CompetitionWorkSeniorityComponent competition={props?.competition} readOnly={true} />

            <CompetitionEducationListViewComponent competition={props?.competition} />

            <CompetitionTrainingReqViewComponent competition={props?.competition} />

            <CompetitionItKnowledgeListViewComponent competition={props?.competition} />

            <CompetitionLanguageListViewComponent competition={props?.competition}  minorityLanguages={false}/>
            
            <CompetitionLanguageListViewComponent competition={props?.competition}  minorityLanguages={true}/>

            <CompetitionOtherCompetencyListViewComponent competition={props?.competition} />

            <CompetitionJobApprovalViewComponent competition={props?.competition} />

            <CompetitionOtherConditionViewComponent competition={props?.competition} />

            <CompetitionBibliographyListViewComponent competition={props?.competition} />

            <CompetitionDocumentViewComponent competition={props?.competition} />            
        </>
    );
};

export default CompetitionJobDetailsComponent;
